import { useEffect } from 'react';
import { RootState, useAppSelector } from '../../store';

function WaitForActivation() {
    const userSettings = useAppSelector((state: RootState) => state.userSettings);
    const i18n = useAppSelector((state: RootState) => state.i18n.i18n);

    useEffect(() => {
        const checkUserSettings = () => {
            if (userSettings.roles.includes('Avency.Jwt:ActiveUser')) {
                document.location.href = '/';
            }
        };
        checkUserSettings();
    }, [userSettings]);

    return (
        <div className="start">
            <div className="container">
                <h1>{i18n.translate({ id: 'title', sourceName: 'WaitForActivation' })}</h1>
                <p>{i18n.translate({ id: 'subTitle', sourceName: 'WaitForActivation' })}</p>
            </div>
        </div>
    );
}

export default WaitForActivation;
